import { TFunction, useGetFarms, useTranslation } from "utils";

import { CropFCPO, CropFormValidationError } from "models";

import { CROP_TYPE_TRANSLATION_KEY } from "pages/app/all-field-view/utils/CropTypeUtils";
import {
  CROP_PERIOD_VALIDATION_RULES,
  CropChange,
  CropValidationViolation,
  validateCrop,
  validateCropChanges,
} from "pages/app/all-field-view/utils/CropValidationUtils";

// overlap messages name the other crop and its type
const getMessageParams = ({ messageParams, overlappingCrop }: CropValidationViolation, t: TFunction) =>
  overlappingCrop
    ? { cropType: t(`fieldTimeline:addCrops.cropTypeName.${CROP_TYPE_TRANSLATION_KEY[overlappingCrop.cropType]}`), cropName: overlappingCrop.name }
    : messageParams;

export const toCropFormValidationError = (violation: CropValidationViolation, t: TFunction, cropFieldId: string): CropFormValidationError => ({
  fieldId: violation.errorFieldId ?? cropFieldId,
  message: t(violation.messageKey, getMessageParams(violation, t)),
  ...(violation.overlappingCrop && { overlappingCrop: violation.overlappingCrop }),
});

export type useValidateCropPeriodsType = {
  validatePeriods: (currentCrop: CropFCPO, existingCrops: CropFCPO[]) => CropFormValidationError[];
  validateCropChanges: (changes: CropChange[], savedCropsByField: Record<string, CropFCPO[]>) => CropFormValidationError[];
};

export const useValidateCropPeriods = (): useValidateCropPeriodsType => {
  const { t } = useTranslation("allFieldView");
  const { currentFarm } = useGetFarms();
  const carbonProgram = currentFarm?.carbonProgram;

  const validatePeriods = (currentCrop: CropFCPO, existingCrops: CropFCPO[]) =>
    validateCrop(
      { crop: currentCrop, otherCrops: existingCrops.filter((crop) => crop.id !== currentCrop.id), carbonProgram },
      CROP_PERIOD_VALIDATION_RULES
    ).map((violation) => toCropFormValidationError(violation, t, ""));

  const validateChanges = (changes: CropChange[], savedCropsByField: Record<string, CropFCPO[]>) =>
    validateCropChanges(changes, savedCropsByField, carbonProgram).map((violation) => toCropFormValidationError(violation, t, violation.fieldId));

  return {
    validatePeriods,
    validateCropChanges: validateChanges,
  };
};
